import BLManager from '$dependencies/BLManager';

const BLM = {
	install(Vue, options) {
		Vue.prototype.$blm = new BLManager();
	},
};

export default BLM;
